module.exports = "/WowActive@2x-2854a14f72e27ef9b953cc9ba01c4afa.png";